import { useMutation } from 'react-query';
import OrdersApi, { CreateOrderResult } from '../../../../../orders/OrdersApi';
import { ICreateOrder } from '../../../../../orders/Entities';
import { PhotographerBookingParamsStorageKey } from '../adapters/dataSharingBetweenNavigation';

export function useSendBookingRequestMutation(
    orderInformation: ICreateOrder,
    onSuccess: (result: CreateOrderResult) => void
) {
    return useMutation(
        ({
            preferredDate,
            notes
        }: {
            preferredDate: Date | null;
            notes: string;
        }): Promise<CreateOrderResult> =>
            OrdersApi.createOrder(
                {
                    ...orderInformation,
                    other: {
                        ...orderInformation.other,
                        preferredTimeOfPhotographing: preferredDate,
                        notes
                    },
                    bookDirectly: false,
                    isBookingRequest: true
                },
                false
            ),
        {
            onSuccess: (result: CreateOrderResult) => {
                window.localStorage.removeItem(PhotographerBookingParamsStorageKey);
                onSuccess(result);
            }
        }
    );
}
